const { listenToMedia, getCurrentMedia } = globals;
let container = null; // Keeping the name, but it will now hold a NodeList/Element

/**
 * Initialize
 */
export function initComponentSidebarMenu() {
    container = document.querySelectorAll('.component-sidebar-menu');
    const isContainerExists = container.length > 0;

    if (!isContainerExists) {
        return;
    }

    listenToMedia(renderSidebar);
    renderSidebar();
    registerEvents();
}

function registerEvents() {
    // Mobile header click
    document.querySelectorAll('.ssm-list-header-mobile').forEach(header => {
        header.addEventListener('click', function (e) {
            e.preventDefault();
            container.forEach(el => el.classList.toggle('open-mobile-menu'));
        });
    });

    // List item click
    document.querySelectorAll('.ssm-list-item:not(.ssm-list-header-mobile)').forEach(item => {
        item.addEventListener('click', function (e) {
            // Remove 'selected' from all items
            document.querySelectorAll('.ssm-list-item').forEach(el => el.classList.remove('selected'));

            // Add 'selected' to clicked item
            const current = e.currentTarget;
            current.classList.add('selected');

            if (getCurrentMedia() === 'mobile') {
                container.forEach(el => {
                    el.classList.toggle('open-mobile-menu');
                    // Find and update mobile text
                    const mobileText = el.querySelector('.ssm-mobile-text');
                    if (mobileText) {
                        mobileText.textContent = current.textContent.trim();
                    }
                });
            }
        });
    });
}

/**
 * Render sidebar for mobile or desktop/tablet
 */
function renderSidebar() {
    switch (getCurrentMedia()) {
        case 'mobile':
            addSelected();
            adjustForButton();
            break;
        default:
    }
}

/**
 * If button add class
 */
function adjustForButton() {
    container.forEach(el => {
        // .closest() replaces .parents() and .querySelector checks for length
        const parentSidebar = el.closest('.sidebar');
        if (parentSidebar && parentSidebar.querySelector('.component-button')) {
            el.classList.add('donate-mobile');
        }
    });
}

/**
 * Add selected text
 */
function addSelected() {
    const headerText = document.querySelector('.ssm-list-header-mobile .ssm-mobile-text');
    const selectedItem = document.querySelector('.ssm-list-item.selected');

    if (headerText && selectedItem) {
        headerText.textContent = selectedItem.textContent.trim();
    }
}

// Auto-initialize
initComponentSidebarMenu();